import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useCallback } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { useDebouncedCallback } from "use-debounce";
import { PreviousAndNextNavigationArrows } from "~/components/AssetModalV2/Header/components/PreviousAndNextNavigationArrows";
import { useGoToAssetPage } from "~/hooks/useGoToAssetPage";
import { usePublicMediaPlayerData } from "~/swr-hooks/mediaPlayer/usePublicMediaPlayerData";
export const PublicBoardAssetNavigationArrows = /*#__PURE__*/ memo(()=>{
    const { shortId } = useShortIdContext();
    const { loadMore, nextAsset, previousAsset, isNearEnd } = usePublicMediaPlayerData(shortId);
    const { goToAssetPage } = useGoToAssetPage();
    const onPreviousClick = useCallback(()=>{
        if (previousAsset) {
            goToAssetPage({
                asset: previousAsset
            });
        }
    }, [
        goToAssetPage,
        previousAsset
    ]);
    const onNextClick = useCallback(()=>{
        if (nextAsset) {
            goToAssetPage({
                asset: nextAsset
            });
            if (isNearEnd) {
                loadMore();
            }
        }
    }, [
        goToAssetPage,
        isNearEnd,
        loadMore,
        nextAsset
    ]);
    const [delayedOnPrevious] = useDebouncedCallback(onPreviousClick, 100);
    const [delayedOnNext] = useDebouncedCallback(onNextClick, 100);
    useHotkeys("left,right", (_keyboardEvent, hotkeysEvent)=>{
        var _hotkeysEvent_keys, _hotkeysEvent_keys1;
        if ((_hotkeysEvent_keys = hotkeysEvent.keys) === null || _hotkeysEvent_keys === void 0 ? void 0 : _hotkeysEvent_keys.includes("left")) {
            delayedOnPrevious();
        } else if ((_hotkeysEvent_keys1 = hotkeysEvent.keys) === null || _hotkeysEvent_keys1 === void 0 ? void 0 : _hotkeysEvent_keys1.includes("right")) {
            delayedOnNext();
        }
    }, [
        delayedOnNext,
        delayedOnPrevious,
        !!nextAsset,
        !!previousAsset
    ]);
    return /*#__PURE__*/ _jsx(PreviousAndNextNavigationArrows, {
        onNextClick: !!nextAsset ? onNextClick : undefined,
        onPreviousClick: !!previousAsset ? onPreviousClick : undefined
    });
});
PublicBoardAssetNavigationArrows.displayName = "PublicBoardAssetNavigationArrows";
